import React from 'react';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Checkbox from 'material-ui/Checkbox';
import Dialog from 'material-ui/Dialog';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import { execute } from 'store/configureStore';
import { transformAreaToPort } from 'sagas/regions/areas';

import constants from "constants";

import MapComponent from 'components/Regions/PortAdd/MapComponent';
import _ from 'lodash';

class ManagementArea extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
          areaName: '',
          openDialog: false,
          openDialogTransformArea: false,
          areaToPort: {
            coordinates: [0, 0],
            country: '',
            unLoCode: ''
          },
          areaToPortErrors: {},
          setAreaAsDefault: false,
        };

        this.onChangeName = this.onChangeName.bind(this);
        this.toggleOpenDialog = this.toggleOpenDialog.bind(this);
        this.toggleAreaAsDefault = this.toggleAreaAsDefault.bind(this);
    }

    toggleOpenDialog(key = 'openDialog') {
        this.setState({
            [key]: !this.state[key],
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.area) {
            if (!this.props.area) {
                this.setState({
                    areaName: nextProps.area.name,
                });

                return;
            }

            this.setState({
                areaName: nextProps.area.name,
            });
        }
    }

    toggleAreaAsDefault(value) {
        this.setState({
            setAreaAsDefault: value,
        }, () => {
            const { area } = this.props;
            area.setAreaAsDefault = this.state.setAreaAsDefault;
            this.props.onChangeArea(area);
        });
    }

    onChangeName(e, value) {
        this.setState({
            areaName: value,
            areaToPortErrors: {
              ...this.state.areaToPortErrors,
              name: ''
            }
        }, () => {
            const { area } = this.props;
            area.name = value;
            this.props.onChangeArea(area);
        });
    }

    handleChangeAreaToPort = (e, value, key) => {
      this.setState({
        areaToPort: {
          ...this.state.areaToPort,
          [key]: value
        },
        areaToPortErrors: {
          ...this.state.areaToPortErrors,
          [key]: ''
        }
      })
    }

    isValidAreaToPort = () => {
      let { areaToPort, areaName } = this.state;
      let errors = {};

      if (!areaName) {
        errors.name = 'required';
      }

      if (!areaToPort.country) {
        errors.country = 'required';
      }

      if (!new RegExp(/^\-?\d+(\.\d+)?$/).test(`${areaToPort.coordinates[0]}`)) {
        errors.coordinates = 'wrong format';
      }

      if (!areaToPort.coordinates[0]) {
        errors.coordinates = 'required';
      }

      if (!new RegExp(/^\-?\d+(\.\d+)?$/).test(`${areaToPort.coordinates[1]}`)) {
        errors.coordinates = 'wrong format';
      }

      if (
        areaToPort.coordinates[0] && areaToPort.coordinates[1]
        && (
          areaToPort.coordinates[0] < -180 || areaToPort.coordinates[0] > 180
          || areaToPort.coordinates[1] < -90 || areaToPort.coordinates[1] > 90
        )
      ) {
        errors.coordinates = 'wrong format';
      }

      if (!areaToPort.coordinates[1]) {
        errors.coordinates = 'required';
      }

      // if (!areaToPort.unLoCode) {
      //   errors.unLoCode = 'required';
      // }

      if (Object.keys(errors).length) {
        this.setState({areaToPortErrors: errors})

        return false;
      }

      return true;
    }

    transformAreaToPort = async () => {
      let {
        router,
        area: { _id: id = '' } = {}
      } = this.props;
      let { areaToPort, areaName } = this.state;

      if (!id) {
        return false;
      }

      if (!this.isValidAreaToPort()) {
        return false;
      }

      let response = await execute(transformAreaToPort, id, {...areaToPort, name: areaName});

      if (response.status === 200) {
        this.toggleOpenDialog('openDialogTransformArea');
        router.push(`/regions/ports/${id}`)
      } else {
        let errors = {};

        response.errors.forEach(er => {
          errors[er.field] = er.messages[0]
        });

        this.setState({areaToPortErrors: errors});
      }
    }

    duplicateArea = () => {
        const { area, createNewArea, onChangeArea } = this.props;
        const areaCopy = _.cloneDeep(area);
        createNewArea();
        setTimeout(() => {
            onChangeArea({
                ...areaCopy,
                _id: undefined,
                isNew: true,
                name: `${areaCopy.name}_duplicate`
            });
        }, 0);
    }

    render() {
        const { areaName, setAreaAsDefault, areaToPort, areaToPortErrors } = this.state;
        const { area,
            recalculateOnSave,
            portFromAutoComplete,
            toggleRecalculate,
            createNewArea,
            createAreaOnServer,
            updateAreaOnServer,
            deleteAreaOnServer,
            showMarkersOnlyInThisArea,
            toggleShowMarkersOnlyInThisArea,
            changeMapView,
            showView,
            user,
            countries } = this.props;

        const actions = [
            <FlatButton
                label='Ok'
                primary
                onClick={() => { this.toggleOpenDialog(); deleteAreaOnServer(); }}
            />,
            <FlatButton
                label='Cancel'
                primary
                onClick={() => this.toggleOpenDialog()}
            />,
        ];

        let btnRender = (<RaisedButton
            label='save'
            primary
            disabled={areaName.length === 0}
            onClick={() => {
                createAreaOnServer({ setAreaAsDefault })
            }}
            style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
            buttonStyle={{ lineHeight: '25px', height: '25px' }}
            labelStyle={{ fontSize: '11px' }}
        />);

        if (area && !area.isNew) {
            btnRender = (<div>
                <RaisedButton
                    label='update'
                    style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
                    buttonStyle={{ lineHeight: '25px', height: '25px' }}
                    labelStyle={{ fontSize: '11px' }}
                    onClick={() => {
                        updateAreaOnServer({ setAreaAsDefault })
                    }}
                    primary
                />
                {user.role === 'admin' && !area.mainRegion ? <RaisedButton
                    label='remove'
                    style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
                    buttonStyle={{ lineHeight: '25px', height: '25px' }}
                    labelStyle={{ fontSize: '11px' }}
                    onClick={() => this.toggleOpenDialog()}
                    secondary
                /> : null}
                {
                  area && area._id &&
                    <RaisedButton
                      label='Area To Port'
                      onClick={() => this.toggleOpenDialog('openDialogTransformArea')}
                      style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
                      buttonStyle={{ lineHeight: '25px', height: '25px' }}
                      labelStyle={{ fontSize: '11px' }}
                    />
                }
            </div>);
        }

        return (
            <div className='paper-block margin-10' style={{ height: '102px' }}>
                <Dialog
                    title='Do you really want to delete area?'
                    actions={actions}
                    open={this.state.openDialog}
                    modal
                />
                <Dialog
                  title='Transform area to port'
                  actions={[
                    <FlatButton
                      label='Ok'
                      primary
                      onClick={() => this.transformAreaToPort()}
                    />,
                    <FlatButton
                      label='Cancel'
                      primary
                      onClick={() => this.toggleOpenDialog('openDialogTransformArea')}
                    />,
                  ]}
                  open={this.state.openDialogTransformArea}
                  modal
                  autoScrollBodyContent={true}
                >
                  <TextField
                    floatingLabelText='Port name'
                    value={ areaName }
                    onChange={this.onChangeName}
                    errorText={areaToPortErrors.name}
                    fullWidth
                  />
                  <SelectField
                    floatingLabelText='Country'
                    value={areaToPort.country}
                    onChange={(event, index, value) => this.handleChangeAreaToPort(null, value, 'country')}
                    maxHeight={200}
                    errorText={areaToPortErrors.country}
                    fullWidth
                  >
                    {
                      countries.map((c, i) => {
                        return <MenuItem key={`country-${i}`} value={c._id} primaryText={c.name} />
                      })
                    }
                  </SelectField>
                  <TextField
                    floatingLabelText='UN LOCODE'
                    value={ areaToPort.unLoCode }
                    onChange={(e, value) => this.handleChangeAreaToPort(null, value, 'unLoCode')}
                    fullWidth
                    errorText={areaToPortErrors.unLoCode}
                  />
                  <TextField
                    floatingLabelText='Latitude'
                    value={ areaToPort.coordinates[0] || 0 }
                    onChange={(event, value) => this.handleChangeAreaToPort(null, [value, areaToPort.coordinates[1]], 'coordinates')}
                    fullWidth
                    errorText={areaToPortErrors.coordinates}
                  />
                  <TextField
                    floatingLabelText='Longitude'
                    value={ areaToPort.coordinates[1] || 0 }
                    onChange={(event, value) => this.handleChangeAreaToPort(null, [areaToPort.coordinates[0], value], 'coordinates')}
                    fullWidth
                    errorText={areaToPortErrors.coordinates}
                  />
                  <MapComponent
                    coordinates={areaToPort.coordinates}
                    change={(key, value) => this.handleChangeAreaToPort(null, value, key)}
                    googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${constants.GOOGLE_MAP_API_KEY}`}
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={<div style={{ width: '100%', height: `300px` }} />}
                    mapElement={<div style={{ height: `100%` }} />}
                  />
                </Dialog>
                <span className='name-block absolute small-name'>Management</span>
                <div className='row'>
                    <div className='col-xs-3' style={{ position: 'relative' }}>
                        <TextField
                            ref='areaName'
                            floatingLabelText='Area name'
                            value={ areaName }
                            onChange={this.onChangeName}
                            fullWidth
                        />
                    </div>

                    <div className='col-xs-4 middle-xs'>
                        {btnRender}
                        <div style={{ display: 'flex', alignItems: 'center' }} >
                            <Checkbox
                                style={{ margin: '10px 0 0 0', fontSize: '12px', width: '60%' }}
                                checked={recalculateOnSave}
                                label='Recalculate area ports'
                                iconStyle={{ marginRight: '10px' }}
                                onCheck={(e, value) => {
                                    toggleRecalculate(value);
                                }}
                            />
                            {
                                area._id &&
                                <RaisedButton
                                    label='Duplicate area'
                                    onClick={this.duplicateArea}
                                    style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
                                    buttonStyle={{ lineHeight: '25px', height: '25px' }}
                                    labelStyle={{ fontSize: '11px', padding: '0 11px' }}
                                />
                            }
                        </div>
                    </div>

                    <div className='col-xs-5 end-xs middle-xs'>
                        <div>
                            <RaisedButton
                                label={showView === 'map' ? 'merge' : 'map'}
                                style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
                                buttonStyle={{ lineHeight: '25px', height: '25px' }}
                                labelStyle={{ fontSize: '11px' }}
                                primary
                                onClick={() => {
                                    if (showView === 'map') {
                                        changeMapView('merge');
                                    } else {
                                        changeMapView('map');
                                    }
                                }}
                            />

                            {area && portFromAutoComplete._id
                                ? <RaisedButton
                                       label='add port to region'
                                       style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
                                       buttonStyle={{ lineHeight: '25px', height: '25px' }}
                                       labelStyle={{ fontSize: '11px' }}
                                       onClick={this.props.addPortToRegion}
                                  />
                            : null }

                            <RaisedButton
                                label='create new'
                                onClick={createNewArea}
                                style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
                                buttonStyle={{ lineHeight: '25px', height: '25px' }}
                                labelStyle={{ fontSize: '11px' }}
                            />
                            <RaisedButton
                                label='create/update (by coords)'
                                onClick={() => changeMapView('addByCoords')}
                                secondary
                                style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
                                buttonStyle={{ lineHeight: '25px', height: '25px' }}
                                labelStyle={{ fontSize: '11px' }}
                            />

                        </div>
                        {area._id ? <div className='start-xs'>
                            <Checkbox
                                style={{ margin: '10px 0 0 0', fontSize: '12px' }}
                                checked={showMarkersOnlyInThisArea}
                                label='Show markers only in this area'
                                onCheck={(e, value) => {
                                    toggleShowMarkersOnlyInThisArea(value);
                                }}
                            />
                        </div> : null }
                    </div>
                </div>
            </div>
        );
    }
}

export default ManagementArea;



// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/Management.jsx